export function AddSong(lib,music) {
    const list_new = [...lib].filter((i) => i.musicSrc !== music.musicSrc)
    return {
        type: 'ADDSONG',
        payload: [...list_new,music]
    };
};

export function RemoveSong(lib,music) {
    const list_new = [...lib].filter((i) => i.musicSrc !== music.musicSrc)
    return {
        type: 'ADDSONG',
        payload: list_new
    };
};